import axios from 'axios'
import Cookies from 'js-cookie'

const state = {
  equipments: [],
  loading: false,
  error: null
}

const mutations = {
  SET_EQUIPMENTS(state, equipments) {
    state.equipments = equipments
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ERROR(state, error) {
    state.error = error
    state.loading = false
  }
}

const actions = {
  async fetchPlayerGymEquipments({ commit, rootState }) {
    try {
      commit('SET_LOADING', true)

      // Get equipment from player inventory
      if (rootState.player.playerData?.inventory?.gym_equipments) {
        commit('SET_EQUIPMENTS', rootState.player.playerData.inventory.gym_equipments)
      }
      
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch gym equipments')
      console.error('Error fetching gym equipments:', error)
    }
  },

  async equipGymEquipment({ commit, dispatch }, { gymId, equipmentId }) {
    try {
      commit('SET_LOADING', true)

      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/gyms/${gymId}/equip`,
        { equipmentId },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      )

      // Refresh data after equipping
      // playerData primeiro: os dados do ginásio são derivados dele
      await dispatch('player/loadPlayerData', null, { root: true })
      await dispatch('employees/fetchGymData', null, { root: true })
      
      commit('SET_LOADING', false)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.error?.message || error.message || 'Failed to equip gym equipment')
      console.error('Error equipping gym equipment:', error)
      throw error
    }
  },

  async unequipGymEquipment({ commit, dispatch }, { gymId, equipmentId }) {
    try {
      commit('SET_LOADING', true)

      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/gyms/${gymId}/unequip`,
        { equipmentId },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      )

      // Refresh data after unequipping
      // playerData primeiro: os dados do ginásio são derivados dele
      await dispatch('player/loadPlayerData', null, { root: true })
      await dispatch('employees/fetchGymData', null, { root: true })
      
      commit('SET_LOADING', false)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.error?.message || error.message || 'Failed to unequip gym equipment')
      console.error('Error unequipping gym equipment:', error)
      throw error
    }
  }
}

const getters = {
  getEquipments: state => state.equipments,
  getLoading: state => state.loading,
  getError: state => state.error,
  
  // Get equipment that are not already installed in a gym
  getAvailableEquipments: state => {
    return state.equipments.filter(equipment => !equipment.gym)
  },
  
  // Get equipment that are already installed in a gym
  getInstalledEquipments: state => {
    return state.equipments.filter(equipment => equipment.gym)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
